import { define, prop } from "@/components/builder/utils";

import BasePreview from "../base";

function ProgressValuePreview({ ...props }) {
  return <BasePreview {...props}>
    <div style={{ width: '70%' }}>
      70%
    </div>
  </BasePreview>
}

function ProgressValueHTML({ calculation, range: { start = 0, end = 100 } = {}, attributes }) {
  const calculatePercentage = getCalculatePercentage(calculation)
  const calculateRange = getCalculateRange(start, end)
  return <>
    <div id="progress-bar" {...attributes}></div>
    <script type="text/javascript" dangerouslySetInnerHTML={{
      __html: `
        (function() {
          var handleUpdateProgress = function(event){
            var calculatePercentage = ${calculatePercentage.toString()};
            var calculateRange = ${calculateRange.toString()};

            var progressElement = document.querySelector("#progress-bar")
            if (!progressElement) {
              return;
            }

            var progress = event && event.detail && event.detail.progress
            if (!progress) {
              progress = JSON.parse(localStorage.getItem("progress") || "{}")
            }

            var step = progress.step || 0
            var total = progress.total || 0

            var percentage = calculatePercentage(step, total)
            var result = calculateRange(percentage)

            progressElement.style.width = result + "%"
            progressElement.innerText = result + "%"
          }

          document.addEventListener('update-progress-bar', handleUpdateProgress)

          handleUpdateProgress()
        })()`,
    }} />
  </>
}

export default define('progress-value', ProgressValuePreview, ProgressValueHTML)
  .property(prop.stylePattern())
  .property(prop.predefined.customClass())
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.textAlign())
  .property(prop.predefined.textShadow())
  .property(prop.group('Calculation', 'calculation').unique()
    .category('default')
    .options(prop.options()
      .add('Based on Step', 'current')
      .add('Based on Completed Steps', 'completed'),
    )
    .own()
    .ignoreDevice(true))
  .property(prop.new('Range', 'range', 'progressRange').category('default').own().ignoreDevice(true))
  .defaultProps({
    range: {
      start: 0,
      end: 100,
    },
    calculation: 'current',
    className: 'min-w-min',
    size: {
      height: 'h-full',
    },
    space: {
      padding: 'px-2',
    },
    border: {
      radius: {
        rounded: '3xl',
      },
    },
    fontSize: 'xs',
    textAlign: {
      horizontal: 'right',
      vertical: 'middle',
    },
    textColor: 'gray-50',
    background: {
      color: 'gray-500',
    },
  })
  .build()

const getCalculatePercentage = (calculation = 'current') => {
  const func = {
    current: `function(step, total) { return (step / total) * 100; }`,
    completed: `function(step, total) { return ((step - 1) / total) * 100; }`,
  }[calculation]
  return func
}

const getCalculateRange = (start, end) => {
  const func = `function(percentage) { return Math.round(${start} + ((${end} - ${start}) * percentage) / 100); }`
  return func
}
